import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import './Permutations.scss';
import { Permutation } from 'src/interfaces/LottoState';
import NumberLine from './Components/NumberLine';

interface PermutaionsProps {
  title: string
  stake?: number,
  permutations?: Permutation[]
  profit?: number,
  numbers?: any,
  sameDrum?: boolean,
  isHorses?: boolean
}

function Permutations({ title, permutations, stake, profit, numbers, sameDrum, isHorses = false }: PermutaionsProps){
  const { t } = useTranslation();

  const concatNumbers = (permutation) => {
    if (permutation.numbers && permutation.bonus){
      return permutation.numbers.concat(permutation.bonus);
    }

    if (permutation.bonus && !permutation.numbers){
      return permutation.bonus;
    }

    return permutation.numbers;
  };

  return (
    <div className="permutations">
      <div className="permutations__title">{ title }</div>
      <div className="permutations__table">
        <div className="permutations__table-head">
          <span>{ t('numbers.selections') }</span>
          <span className="permutations__right-align">{ t('numbers.stake') }</span>
          <span className="permutations__right-align">{ t('numbers.odds') }</span>
          <span className="permutations__right-align">{ t('numbers.potReturn') }</span>
        </div>
        <div className="permutations__table-body">
          {
            _.map(permutations, (permutation, index) => {

              return (
                <Fragment key={ index }>
                  <NumberLine
                    numbers={ !isHorses ? concatNumbers(permutation) : permutation.numbers }
                    stake={ stake }
                    odds={ permutation.odds }
                    profit={ profit }
                    sameDrum={ sameDrum }
                    selectedNumbers={ numbers }
                    isHorses= { isHorses }
                  />
                </Fragment>
              );
            })
          }
        </div>
      </div>
    </div>
  );
}

export default Permutations;
